import { TransactionsPage } from 'features/transactions';

export const AdminTransactionsPage: React.FC = () => <TransactionsPage />;
